import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { Navigate } from "react-router-dom";
import { tokenRequest } from "../../config";
import ErrorDisplay from "../../components/ErrorDisplay";

const Login = ({ config }) => {
  const authRequest = {
    ...tokenRequest
  };
  return (
    <MsalAuthenticationTemplate 
      interactionType={InteractionType.Redirect} 
      authenticationRequest={authRequest}
      errorComponent={ErrorDisplay}
    >
      <Navigate to={{ pathname: "/secured/dashboard" }} />
    </MsalAuthenticationTemplate>
  );
};

export default Login;
